const GetProxy = () => {
    const proxy = window.BE_URL;
    return proxy;
}
export default GetProxy;


